export class ListRestoreAccountsRequest {
    'filters';
    'sorts';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "RestoreAccountsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortRestoreAccountsBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreAccountsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
